import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptySpecialOffer({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M177.8 150.01c-39.25-5.43-77.3 12.49-102.3 12.49-40.5 0-80.22-29.03-67.63-70 12.89-41.9 44.95-32.48 107.29-71.78 57.4-36.2 102.49 19.82 111.6 51.53 9.13 31.7 3.72 85.05-48.96 77.76z"
          fill="#E9EDFB"
        />
        <path
          d="M225.01 126.8l-.4.9c-7.13 15.34-21.52 25.81-46.81 22.31-39.25-5.43-77.3 12.49-102.3 12.49-33.35 0-66.18-19.68-69.7-49.51C31 125.54 64.67 128 119.5 110.5c54.61-17.43 85.52-2.16 105.51 16.3z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <rect fill="#FFD623" x={74} y={90} width={84} height={53} rx={4} />
        <path fill="#FF952B" d="M111 143.12h10V90h-10z" />
        <path
          d="M140.44 82.93a2.25 2.25 0 01-2.2-2.75 25.53 25.53 0 019.73-14.64 2.25 2.25 0 012.64 3.65 20.9 20.9 0 00-7.97 11.98 2.25 2.25 0 01-2.2 1.76"
          fill="#FCC083"
        />
        <path fill="#FECE00" d="M127.22 79.85h4.18v-4.5h-4.18z" />
        <path
          fill="#FF952B"
          d="M161.02 45.07l7.28 2.47 6.17-4.6-.1 7.7 6.28 4.43-7.35 2.29-2.28 7.34-4.44-6.28-7.7.1 4.6-6.16-2.46-7.29"
        />
        <path fill="#FECE00" d="M168.79 84.61h4.18v-4.5h-4.18zm15.55-15.21h4.18v-4.5h-4.18z" />
        <path
          d="M153.93 84.27a2.25 2.25 0 01-1.9-3.45c2.43-3.85 6-6.95 10.32-8.96a24.25 24.25 0 0113.5-2.15 2.25 2.25 0 11-.6 4.46 20.43 20.43 0 00-19.42 9.05 2.25 2.25 0 01-1.9 1.05"
          fill="#FCC083"
        />
        <path
          d="M96.44 32.67a9.16 9.16 0 014.94 4.7 9.68 9.68 0 016.18-4.32 9.36 9.36 0 0110.9 7.12l.06.27c.7 3.64-.72 7.31-3.9 10.06-2.8 2.42-9.09 5.28-12.27 6.65l-.39 3.74-3.11-2.1C95.7 60.36 89.6 63.26 86 63.85c-.74.12-1.46.17-2.16.17a10.1 10.1 0 01-8.06-3.65 9.36 9.36 0 011.38-13.15 9.68 9.68 0 017.11-1.98 9.14 9.14 0 01-.38-6.71 9.81 9.81 0 0112.55-5.86zM80.25 51.04a4.44 4.44 0 00-.66 6.24c1.64 2.02 4.23 1.95 5.62 1.72 2.03-.33 5.56-1.81 8.58-3.22a68.95 68.95 0 01-4.81-2.86c-1.5-.95-2.92-1.85-4.35-2.54-1.21-.59-3.21-.28-4.38.66zM91.13 37.4l-.24.12a4.94 4.94 0 00-2.35 2.58c-.6 1.8.3 3.48.9 4.32 1.54 2.2 5.33 5.3 8.38 7.6.2-3.82.27-8.71-.42-11.31-.26-.95-.91-2.61-2.51-3.36l-.23-.1c-1-.4-2.38-.33-3.53.15zm18.22.38c-.28 0-.57.03-.85.09-1.47.28-3 1.63-3.32 2.93-.39 1.54-.61 3.2-.85 4.96a68.83 68.83 0 01-.9 5.53c3.02-1.41 6.42-3.17 7.98-4.5 1.03-.9 2.67-2.73 2.33-5.15l-.04-.26a4.45 4.45 0 00-4.35-3.6z"
          fill="#FF952B"
        />
        <path
          d="M150.54 59.1L70.7 96.35a1.8 1.8 0 01-2.4-.87l-8.13-16.66a1.8 1.8 0 01.87-2.4l79.84-37.23a1.8 1.8 0 012.4.88l8.13 16.66c.42.9.03 1.97-.87 2.39z"
          fill="#FFDA3B"
        />
        <path fill="#FF952B" d="M105.65 80.11l-9.5-20.17 9.4-4.5 9.6 19.91z" />
      </g>
    </svg>
  );
}

SvgPicEmptySpecialOffer.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptySpecialOffer.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptySpecialOffer svgRef={ref} {...props} />
));
export default ForwardRef;
